module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"validating":"validating...","valid_ticket":"Valid ticket","invalid_ticket":"Invalid ticket","validated_already":"The ticket was already validated on"},"hu":{"validating":"érvényesítés...","valid_ticket":"Érvényes jegy","invalid_ticket":"Érvénytelen jegy","validated_already":"A jegy már érvényesítve lett ekkor -"}}')
  delete Component.options._Ctor
}
